<template>
  <div class="categoryHead categoryHeadSub">
    <div class="inner">
      <nav class="categoryHeadArea">
        <ul v-if="this.isTcc10Sen()" class="specials">
          <li><router-link to="/artworks/Tcc10Sen2019/201901" :class="{ location: isSelected('/artworks/Tcc10Sen2019/2019') }">2019</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2018/201801" :class="{ location: isSelected('/artworks/Tcc10Sen2018/2018') }">2018</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2017/201701" :class="{ location: isSelected('/artworks/Tcc10Sen2017/2017') }">2017</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2016/201601" :class="{ location: isSelected('/artworks/Tcc10Sen2016/2016') }">2016</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2015/201501" :class="{ location: isSelected('/artworks/Tcc10Sen2015/2015') }">2015</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2014/201401" :class="{ location: isSelected('/artworks/Tcc10Sen2014/2014') }">2014</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2013/201302" :class="{ location: isSelected('/artworks/Tcc10Sen2013/2013') }">2013</router-link></li>
          <li><router-link to="/artworks/Tcc10Sen2012/201201" :class="{ location: isSelected('/artworks/Tcc10Sen2012/2012') }">2012</router-link></li>
        </ul>
        <ul v-else-if="this.isJapan100Views()" class="specials">
          <li><router-link v-for="area of areas" :key="area.id" :to="`/artworks/Japan100Views/${area.id}`" :class="{ location: isPrefSelected(area.name) }">{{area.name}}</router-link></li>
        </ul>
        <ul v-else-if="this.isMyPrecious()" class="specials">
          <li><router-link to="/artworks/MyPrecious/200004" :class="{ location: isMyPreciousSelected('大切なあの人') }">「大切なあの人」部門</router-link></li>
          <li><router-link to="/artworks/MyPrecious/200003" :class="{ location: isMyPreciousSelected('愛しい生きもの') }">「愛しい生きもの」部門</router-link></li>
        </ul>
      </nav>
    </div><!-- /inner-->
  </div><!-- /categoryHead-->
</template>

<script>
import { mapGetters } from 'vuex'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    isTcc10Sen () {
      return this.$route.path.indexOf('/artworks/Tcc10Sen') === 0
    },
    isJapan100Views () {
      return this.$route.path.indexOf('/artworks/Japan100Views') === 0
    },
    isMyPrecious () {
      return this.$route.path.indexOf('/artworks/MyPrecious') === 0
    },
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    isPrefSelected (str) {
      const winnerId = this.$route.params.id
      if (winnerId) {
        const winner = this.winnersById(winnerId)
        const ret = this.prefecturesMap[winner.winningWorks[0].title] === str
        return ret
      }
      return false
    },
    isMyPreciousSelected (str) {
      const winnerId = Number(this.$route.params.id)
      if (str === '大切なあの人') {
        const ret = [200004, 200009, 200008, 200006, 200007].indexOf(winnerId) >= 0
        return ret
      } else if (str === '愛しい生きもの') {
        const ret = [200003, 200010, 200002, 200001, 200005].indexOf(winnerId) >= 0
        return ret
      }
      return false
    },
    getAreaWinnerId (areaName) {
      for (const area of this.areas) {
        if (area.name === areaName) {
          return area.id
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'winners',
      'winnersById',
      'areas'
    ])
  },
  created () {
  },
  mounted () {
  }
}
</script>
